import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClaimTypeSearchRequest } from '../../../../models/net/request/claim-type-search-request';
import { ClaimType } from '../../../../models/data/identity/claim-type';
import { AppService } from '../../../../services/app.service';
import { ClaimTypeService } from '../../../../services/identity/claim-types/claim-type.service';
import { SearchComponent } from '../../../base/search/search.component';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-claim-types',
    templateUrl: './claim-types.component.html',
    styleUrls: ['./claim-types.component.css', '../../../../app.component.css']
})

export class ClaimTypesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "ClaimTypeUID", "Delete"];
    public override searchRequest: ClaimTypeSearchRequest = new ClaimTypeSearchRequest();
    public override searchResult: ClaimType[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.ClaimTypeSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: ClaimTypeService) {

        super(appService, sessionService, itemService, "claimtype", "ClaimType");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.ClaimTypeSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: ClaimTypeSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: ClaimTypeSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: ClaimType) => i.ClaimTypeId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: ClaimTypeSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
